module.exports = __webpack_public_path__ + "static/media/starAlert.466e2974.svg";